
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
 * This file should be your main import to use Prisma. Through it you get access to all the models, enums, and input types.
 * If you're looking for something you can import in the client-side of your application, please refer to the `browser.ts` file instead.
 *
 * 🟢 You can import this file directly.
 */

import * as process from 'node:process'
import * as path from 'node:path'
import { fileURLToPath } from 'node:url'
globalThis['__dirname'] = path.dirname(fileURLToPath(import.meta.url))

import * as runtime from "@prisma/client/runtime/client"
import * as $Enums from "./enums.ts"
import * as $Class from "./internal/class.ts"
import * as Prisma from "./internal/prismaNamespace.ts"

export * as $Enums from './enums.ts'
export * from "./enums.ts"
/**
 * ## Prisma Client
 * 
 * Type-safe database client for TypeScript
 * @example
 * ```
 * const prisma = new PrismaClient({
 *   adapter: new PrismaPg({ connectionString: process.env.DATABASE_URL })
 * })
 * // Fetch zero or more Branches
 * const branches = await prisma.branch.findMany()
 * ```
 * 
 * Read more in our [docs](https://pris.ly/d/client).
 */
export const PrismaClient = $Class.getPrismaClientClass()
export type PrismaClient<LogOpts extends Prisma.LogLevel = never, OmitOpts extends Prisma.PrismaClientOptions["omit"] = Prisma.PrismaClientOptions["omit"], ExtArgs extends runtime.Types.Extensions.InternalArgs = runtime.Types.Extensions.DefaultArgs> = $Class.PrismaClient<LogOpts, OmitOpts, ExtArgs>
export { Prisma }

/**
 * Model Branch
 * 
 */
export type Branch = Prisma.BranchModel
/**
 * Model User
 * 
 */
export type User = Prisma.UserModel
/**
 * Model RolePermission
 * 
 */
export type RolePermission = Prisma.RolePermissionModel
/**
 * Model AppSetting
 * 
 */
export type AppSetting = Prisma.AppSettingModel
/**
 * Model RefreshToken
 * 
 */
export type RefreshToken = Prisma.RefreshTokenModel
/**
 * Model Company
 * 
 */
export type Company = Prisma.CompanyModel
/**
 * Model Category
 * 
 */
export type Category = Prisma.CategoryModel
/**
 * Model GenericMedicine
 * 
 */
export type GenericMedicine = Prisma.GenericMedicineModel
/**
 * Model MedicineCatalogItem
 * 
 */
export type MedicineCatalogItem = Prisma.MedicineCatalogItemModel
/**
 * Model Product
 * 
 */
export type Product = Prisma.ProductModel
/**
 * Model ProductBatch
 * 
 */
export type ProductBatch = Prisma.ProductBatchModel
/**
 * Model Purchase
 * 
 */
export type Purchase = Prisma.PurchaseModel
/**
 * Model PurchaseItem
 * 
 */
export type PurchaseItem = Prisma.PurchaseItemModel
/**
 * Model Sale
 * 
 */
export type Sale = Prisma.SaleModel
/**
 * Model SaleItem
 * 
 */
export type SaleItem = Prisma.SaleItemModel
/**
 * Model Return
 * 
 */
export type Return = Prisma.ReturnModel
/**
 * Model ReturnItem
 * 
 */
export type ReturnItem = Prisma.ReturnItemModel
/**
 * Model Payment
 * 
 */
export type Payment = Prisma.PaymentModel
/**
 * Model StockMovement
 * 
 */
export type StockMovement = Prisma.StockMovementModel
/**
 * Model BillingCollection
 * 
 */
export type BillingCollection = Prisma.BillingCollectionModel
/**
 * Model StockAdjustment
 * 
 */
export type StockAdjustment = Prisma.StockAdjustmentModel
/**
 * Model StockAuditEntry
 * 
 */
export type StockAuditEntry = Prisma.StockAuditEntryModel
/**
 * Model AuditLog
 * 
 */
export type AuditLog = Prisma.AuditLogModel
